import { observer } from 'mobx-react-lite';
import Ingressinho from 'assets/imgs/ingressinho.svg';
import locationStore from 'stores/LocationStore';
import { Button } from '@sympla/sympla-components';

import * as styles from './EmptySearch.css';

function EmptySearch({
  hasOtherResult,
  hasButtonChangeLocation,
  hasMargin = true,
}: {
  hasOtherResult?: boolean;
  hasButtonChangeLocation?: boolean;
  hasMargin?: boolean;
}) {
  return (
    <div className={`${styles.Container} ${hasMargin && styles.ContainerPadding}`} data-testid="search-empty-container">
      {hasOtherResult ? (
        <div className={styles.ContentText} data-testid="search-empty-other-results">
          <Ingressinho width={44} height={44} className={styles.ImgStyle} role="img" aria-label="Ícone ilustrativo de busca sem resultados" />
          <div>
            <h3 className={styles.Title}>Poxa, sua busca não retornou resultados. </h3>
            <p className={styles.TextStyle}> Mas encontramos eventos similares em outras cidades.</p>
          </div>
        </div>
      ) : (
        <div className={styles.Content} data-testid="search-empty-no-results">
          <Ingressinho
            width={104}
            height={104}
            className={styles.ImgStyleNoResult}
            role="img"
            aria-label="Ícone ilustrativo de busca sem resultados"
          />
          <h3 className={styles.Title}>Sem resultados</h3>
          <p className={styles.TextStyle}>Não encontramos eventos que corresponda à sua busca.</p>
          <p className={styles.TextStyle}>Tente buscar outras palavras-chave</p>
        </div>
      )}
      {hasButtonChangeLocation && (
        <Button
          variant="outline"
          onClick={() => locationStore.setIsLocationModalVisible(true)}
          upperCase={false}
          size="small"
          aria-label="Trocar localização"
          data-testid="search-empty-change-location-button"
        >
          Trocar localização
        </Button>
      )}
    </div>
  );
}

export default observer(EmptySearch);
